module.exports = __webpack_public_path__ + "static/taps-bg-a34f0976407f9c45ce1c1120aae9abf3.png";